"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttachSelect = void 0;
var _LoadingOutlined2 = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/LoadingOutlined.svg"));
var _chips = _interopRequireDefault(require("../../chips"));
var _dropdown = _interopRequireDefault(require("../../dropdown"));
var _icon = _interopRequireDefault(require("../../icon"));
var _menu = _interopRequireDefault(require("../../menu"));
var _space = _interopRequireDefault(require("../../space"));
var _text = _interopRequireDefault(require("../../text"));
var _ahooks = require("ahooks");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../_util/utils");
var _select = require("../../select");
var _NameIdSpace = require("./NameIdSpace");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const AttachSelect = exports.AttachSelect = /*#__PURE__*/_react.default.forwardRef((props, _ref) => {
  const {
    placeholder,
    loading,
    disabled,
    disabledTip,
    readonly,
    optionsLoading,
    children,
    getPopupContainer,
    idCopyable,
    overlayStyle,
    icon,
    ...restProps
  } = props;
  const attrs = (0, _utils.pickDomAttrs)(restProps);
  const [mouse, setMouse] = (0, _react.useState)(false);
  const [active, onActiveChange] = (0, _ahooks.useControllableValue)(props, {
    defaultValue: false,
    defaultValuePropName: 'defaultActive',
    valuePropName: 'active',
    trigger: 'onActiveChange'
  });
  const ref = (0, _react.useRef)(null);
  (0, _ahooks.useClickAway)(() => {
    active === true && onActiveChange(false);
  }, ref);
  const [value, onChange] = (0, _ahooks.useControllableValue)(props, {
    defaultValue: undefined,
    defaultValuePropName: 'defaultValue',
    valuePropName: 'value',
    trigger: 'onChange'
  });
  _react.default.useImperativeHandle(_ref, () => ({
    value,
    onChange,
    active,
    onActiveChange
  }), [value, active]);
  const menu = (0, _react.useMemo)(() => {
    const menuInfo = _react.default.Children.map(children, item => {
      return item === null || item === void 0 ? void 0 : item.props;
    });
    return !!(menuInfo !== null && menuInfo !== void 0 && menuInfo.length) && !optionsLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_menu.default, {
      selectable: true,
      selectedKeys: [value === null || value === void 0 ? void 0 : value.id],
      items: menuInfo === null || menuInfo === void 0 ? void 0 : menuInfo.map(item => ({
        label: item.children,
        key: item.value,
        disabled: item.disabled,
        onClick: () => {
          if (item.value !== (value === null || value === void 0 ? void 0 : value.id)) {
            onActiveChange(false);
            onChange({
              name: item.name,
              id: item.value
            });
          }
        }
      }))
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.NotFoundContent, {
      optionsLoading: optionsLoading
    });
  }, [children, value, optionsLoading]);
  const placeholderRender = (0, _react.useMemo)(() => {
    if (((value === null || value === void 0 ? void 0 : value.name) === undefined || (value === null || value === void 0 ? void 0 : value.id) === undefined) && placeholder) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _classnames.default)('placeholder', {
          disabled
        }),
        onClick: () => {
          !disabled && onActiveChange(true);
        },
        children: placeholder
      });
    } else {
      return undefined;
    }
  }, [value, placeholder, disabled]);
  const edit = (0, _react.useMemo)(() => {
    if (loading) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
          type: "LoadingOutlined",
          className: "attachSelect-loading"
        })
      });
    } else if (readonly) {
      return readonly === true ? undefined : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: readonly
      });
    } else if (placeholderRender) {
      return undefined;
    } else if (mouse || active) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        onClick: () => {
          onActiveChange(true);
        },
        className: "attachSelect-edit",
        children: "Edit"
      });
    } else {
      return undefined;
    }
  }, [loading, placeholderRender, readonly, mouse, active]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dropdown.default, {
      isScroll: true,
      dropdownRender: () => menu,
      open: active && !loading,
      disabled: disabled,
      getPopupContainer: getPopupContainer,
      overlayStyle: overlayStyle,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_chips.default, {
        ...attrs.data,
        type: "filled",
        active: active,
        disabled: disabled,
        readonly: !!readonly,
        style: {
          cursor: 'default'
        },
        suffix: edit,
        onMouseEnter: () => {
          !disabled && !readonly && setMouse(true);
        },
        onMouseLeave: () => {
          !disabled && !readonly && setMouse(false);
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_space.default, {
          children: [placeholderRender ? undefined : icon, /*#__PURE__*/(0, _jsxRuntime.jsx)(_NameIdSpace.NameIdSpace, {
            ellipsis: true,
            isLinkStyle: !!placeholderRender,
            name: placeholderRender || (value === null || value === void 0 ? void 0 : value.name),
            id: idCopyable && value !== null && value !== void 0 && value.id ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_text.default, {
              copyable: {
                text: value === null || value === void 0 ? void 0 : value.id
              },
              children: "ID:".concat(value === null || value === void 0 ? void 0 : value.id)
            }) : value === null || value === void 0 ? void 0 : value.id,
            disabled: disabled,
            disabledTip: disabledTip
          })]
        })
      })
    })
  });
});
const AttachSelectOption = props => {
  return null;
};
AttachSelect.Option = AttachSelectOption;